<template>
  <section id="section__money" class="px-3">
    <v-row no-gutters class="landing-container text-center">
      <v-col cols="12">
        <p class="font--p-5">현명한 선택에 지금 참여하세요!</p>
      </v-col>
      <template v-for="(item, i) in money">
        <v-col cols="12" class="text-right mt-10" :key="i">
          <span class="font-size--35 font-weight-black">{{ item.won }}</span>
          <p class="font--m-5">{{ item.text }}</p>
        </v-col>
      </template>

      <v-col v-if="showApply" cols="12" class="mt-5 text-center px-8">
        <v-btn block class="apply-btn" :to="{ name: 'signup/agreements/nice' }">
          번개입금 신청하기
        </v-btn>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  props: {
    showApply: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      money: [
        {
          text: '누적 정산 금액',
          won: '578억원',
        },
        {
          text: '이용자 재이용률',
          won: '98%',
        },
        {
          text: '매일 신청자 수',
          won: '1,560명',
        },
        {
          text: '고객 만족도',
          won: '9.7/10.0',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
#section__money {
  background-color: #ffffff;
  display: flex !important;
  flex-direction: column;
  overflow: hidden;

  .apply-btn {
    background-color: #82d4fe;
    height: 50px;
    font-size: 20px;
  }
}
</style>
